module.exports = new __parcel__URL__("service-requests.266aad3f.svg").toString();